// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"Skeleton_ProseMirror___NLMx","skeleton":"Skeleton_skeleton__zRo__","loading":"Skeleton_loading__1rhfh"};